import script from "./LootBoxOpenPrizeOdd.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxOpenPrizeOdd.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxOpenPrizeOdd.vue?vue&type=style&index=0&id=652ada13&lang=scss"

const __exports__ = script;

export default __exports__